module.exports = __webpack_public_path__ + "img/cc.2da4bb97.svg";